/* UTM URL builder — turns campaign config into ready-to-use ad destination URLs.
   Used by the Growth admin to export Google Ads final URLs. */
import { SITE_URL } from "@/seo/config";

export function buildUtmUrl(landingSlug, { source = "google", medium = "cpc", campaign, term, content } = {}) {
  const base = `${SITE_URL}/${String(landingSlug).replace(/^\//, "")}`;
  const params = new URLSearchParams();
  params.set("utm_source", source);
  params.set("utm_medium", medium);
  if (campaign) params.set("utm_campaign", campaign);
  if (term) params.set("utm_term", term);
  if (content) params.set("utm_content", content);
  return `${base}?${params.toString()}`;
}

export function campaignFinalUrl(c) {
  return buildUtmUrl(c.landingSlug, { source: "google", medium: "cpc", campaign: c.id });
}
